import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/AdminRecentSales.css'; // Reutilizamos los estilos existentes

const AdminRecentExpenses = () => {
  const [recentExpenses, setRecentExpenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRecentExpenses = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const token = localStorage.getItem('token');
        if (!token) {
          console.error('No se encontró token de autenticación');
          setError('Error de autenticación');
          setLoading(false);
          return;
        }
        
        const response = await axios.get('/api/stats/recent-expenses', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        console.log('Datos de gastos recientes recibidos:', response.data);
        
        // Verificar que la respuesta sea un array válido
        if (Array.isArray(response.data)) {
          setRecentExpenses(response.data);
        } else {
          console.error('Respuesta no es un array válido:', response.data);
          setRecentExpenses([]);
          setError('Error en el formato de datos recibidos');
        }
      } catch (err) {
        console.error('Error al cargar gastos recientes:', err);
        // Si es un error 404 o el usuario no tiene negocio registrado, mostrar mensaje apropiado
        if (err.response?.status === 404 || err.response?.status === 500) {
          setRecentExpenses([]);
          setError(null);
        } else {
          setError('Error al cargar gastos recientes');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchRecentExpenses();
  }, []);

  if (loading) {
    return (
      <div className="recent-sales-container">
        <h2>Gastos Recientes</h2>
        <p>Cargando gastos recientes...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="recent-sales-container">
        <h2>Gastos Recientes</h2>
        <p className="error-message">{error}</p>
      </div>
    );
  }

  return (
    <div className="recent-sales-container">
      <h2>Gastos Recientes</h2>
      {recentExpenses && recentExpenses.length > 0 ? (
        <div className="recent-sales-list">
          <table className="admin-recent-expenses-table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Punto de Venta</th>
                <th>Categoría</th>
                <th>Nombre del Gasto</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {recentExpenses.map((expense, index) => (
                <tr key={index}>
                  <td>
                    {expense.fecha ? (() => {
                      try {
                        // Si ya viene en formato correcto (aaaa-mm-dd), usar directamente
                        if (typeof expense.fecha === 'string' && expense.fecha.match(/^\d{4}-\d{2}-\d{2}/)) {
                          return expense.fecha.substring(0, 10);
                        }
                        // Si viene en otro formato, convertir
                        const date = new Date(expense.fecha);
                        if (isNaN(date.getTime())) {
                          return 'N/A';
                        }
                        return date.toISOString().substring(0, 10);
                      } catch (error) {
                        console.error('Error al formatear fecha:', error);
                        return 'N/A';
                      }
                    })() : 'N/A'}
                  </td>
                  <td>{expense.punto_venta || 'N/A'}</td>
                  <td>{expense.categoria || 'N/A'}</td>
                  <td>{expense.nombre_gasto || 'N/A'}</td>
                  <td className="total-column">${parseFloat(expense.total || 0).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>Sin datos de gasto para mostrar.</p>
      )}
    </div>
  );
};

export default AdminRecentExpenses;
